$(document).ready(function(){
  //Static Pages JS START
  $('#SplitDays').change(function() {
    setTimeout(function () {
    var selected = $('#SplitDays option:selected');
    var newVal = (selected.val()); 
    localStorage.setItem("MenuType",newVal);
      localStorage.setItem("TabName","Introduction");
      if((newVal == "4-Day Split"))
      {
        var linkGet = "/pages/tab-4-days";
        window.location.href = linkGet;
      }
       else if((newVal == "5-Day Split"))
      {
        var linkGet = "/pages/tab-5-days";
        window.location.href = linkGet;
      }
         else if((newVal == "3-Day Split"))
      {
        var linkGet = $(".IntroductionCust a").attr("href");
        window.location.href = linkGet;
      }
      else{
      location.reload();
      }
      }, 1000);
});
  $("#MobTabs").change(function(){
    var selected = $('#MobTabs option:selected');
    var newVal = (selected.html()); 
    localStorage.setItem("TabName",newVal);
    var GetLink = $('#MobTabs option:selected').attr("data-link");
     window.location.href = GetLink;
  })
  var MobTabName = (localStorage.getItem("TabName"));
  $('#MobTabs').val(MobTabName);
  var MenuVal = (localStorage.getItem("MenuType"));
  if((localStorage.getItem("MenuType") === null) || (MenuVal == "3-Day Split"))
  {
    $(".CustomDay4").hide();
    $(".CustomDay5").hide();
   $('#SplitDays').val("3-Day Split");
    $("ul.list-tabs-link").addClass("day3split");
    if ($(window).width() < 768) {
    $("#MobTabs").show();
    }
  }
  else if(MenuVal == "4-Day Split")
  {
    $("#MobTabs").hide();
    $(".list-tabs-link").hide();
   $(".CustomDay4").show();
    $('#SplitDays').val(MenuVal);
    $('li.Pumpday2').hide();
    $("ul.list-tabs-link").addClass("day4split");
  }
  else if(MenuVal == "5-Day Split")
  {
    $("#MobTabs").hide();
    $(".list-tabs-link").hide();
    $(".CustomDay4").show();
    $(".CustomDay5").show();
    $('#SplitDays').val(MenuVal);
    $('li.Pumpday1').hide();
    $('li.Pumpday2').hide();
    $("ul.list-tabs-link").addClass("day5split");
  }
  
//Static Pages JS END
  
  setTimeout(function () {
  setInterval(function () {
    $("input#BBB_membership_button_stripe").removeAttr("disabled");
    var divhtml = $(".bold-form-group.confirm_checkbox.got_error label#n_check-error").html();
    if(divhtml == "This checkbox is required."){}else{
    $(".bold-form-group.confirm_checkbox.got_error label#n_check-error").html("This checkbox is required.");
      $(".bold-form-group.confirm_checkbox label#n_check-error").show();
    }
  }, 200);
    $("input#BBB_membership_button_stripe").removeAttr("disabled");
}, 2000);
$('body').on('click', 'input#BBB_membership_button_stripe', function() {
  if($("input#check_BBB").is(":checked")){
    $(".bold-form-group.confirm_checkbox").removeClass("got_error");
  }else{
    $(".bold-form-group.confirm_checkbox").addClass("got_error");
  }
})

  $('body').on('click', 'input#check_BBB', function() {
    if($(this).siblings("label#n_check-error").length){
  if($("input#check_BBB").is(":checked")){
    $(".bold-form-group.confirm_checkbox").removeClass("got_error");
  }else{
    $(".bold-form-group.confirm_checkbox").addClass("got_error");
  }
    }
})
  

});


$(document).ready(function () {
  $(".carousel") && $(".carousel").slick({
    infinite: !0,
    centerMode: true,
    centerPadding: 0,
    slidesToShow: 5,
    slidesToScroll: 1,
    draggable: !1,
    dots: false,
    arrows: true,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          arrows: !0,
          centerMode: !0,
          centerPadding: "0",
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 480,
        settings: {
          arrows: !0,
          centerMode: !0,
          centerPadding: "0",
          slidesToShow: 1,
        },
      },
    ],
  });
  // Glute increase carousels
  $(".testimonals__carousel").slick({
    centerMode: true,
    centerPadding: "60px",
    slidesToShow: 3,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          centerMode: true,
          centerPadding: "60px",
          slidesToShow: 2,
          arrows: false,
        },
      },
      {
        breakpoint: 564,
        settings: {
          centerMode: true,
          centerPadding: "40px",
          slidesToShow: 1,
        },
      },
    ],
  });

  $(".members-pricing__carousel").slick({
    slidesToShow: 2,
    centerPadding: "60px",
    centerMode: false,
    infinite: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          centerMode: true,
          centerPadding: "60px",
          slidesToShow: 1,
          initialSlide: 1,
        },
      },
    ],
  });

  // End carousels

  // back to top
  $(".logo").on("click", function (e) {
    e.preventDefault();
    $(".nav-toggle").removeClass("open");
    $(".menu-right").removeClass("collapse");
    $("html, body").animate(
      {
        scrollTop: 0,
      },
      750,
      "easeInOutQuad"
    );
  });

  // smooth scroll between sections
  $('a[href^="#"]').on("click", function (event) {
    var $target = $(this.getAttribute("href"));

    if ($target.length) {
      event.preventDefault();
      $("html, body").stop().animate(
        {
          scrollTop: $target.offset().top,
        },
        750,
        "easeInOutQuad"
      );
    }
  });

  // TOGGLE HAMBURGER & COLLAPSE NAV
  $(".nav-toggle").on("click", function () {
    $(this).toggleClass("open");
    $(".menu-right").toggleClass("collapse");
  });
  // REMOVE X & COLLAPSE NAV ON ON CLICK
  $(".menu-right a").on("click", function () {
    $(".nav-toggle").removeClass("open");
    $(".menu-right").removeClass("collapse");
  });

  // SHOW/HIDE NAV

  // Hide Header on on scroll down
  var didScroll;
  var lastScrollTop = 0;
  var delta = 5;
  var navbarHeight = $("header").outerHeight();

  $(window).scroll(function (event) {
    didScroll = true;
  });

  setInterval(function () {
    if (didScroll) {
      hasScrolled();
      didScroll = false;
    }
  }, 250);

  function hasScrolled() {
    var st = $(this).scrollTop();

    // Make sure they scroll more than delta
    if (Math.abs(lastScrollTop - st) <= delta) return;

    // If they scrolled down and are past the navbar, add class .nav-up.
    // This is necessary so you never see what is "behind" the navbar.
    if (st > lastScrollTop && st > navbarHeight) {
      // Scroll Down
      $("header").removeClass("show-nav").addClass("hide-nav");
      $(".nav-toggle").removeClass("open");
      $(".menu-right").removeClass("collapse");
    } else {
      // Scroll Up
      if (st + $(window).height() < $(document).height()) {
        $("header").removeClass("hide-nav").addClass("show-nav");
      }
    }

    lastScrollTop = st;
  }
});
